/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.15.0
 */

import { IPagePaymentsTranslation } from '../../types';

export const initPagePaymentsTranslation: IPagePaymentsTranslation = {
    table: {
        account: {
            header: '',
            dataName: '',
        },
        amount: {
            header: '',
            dataName: '',
        },
        msisdn: {
            header: '',
            dataName: '',
        },
        operationDate: {
            header: '',
            dataName: '',
        },
        paymentDocument: {
            header: '',
            dataName: '',
        },
        paymentSource: {
            header: '',
            dataName: '',
        },
        paymentType: {
            header: '',
            dataName: '',
        },
    },
    title: {
        dropFilters: '',
        export: '',
        label: '',
    },
}
